// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_5kp","cls2":"Base-cls2_87f Base-cls1_5kp"};